import { useTheme } from '@material-ui/core'
import { X } from 'lucide-react'
import { useContext, useEffect, useState } from 'react'
import { SocketContext } from '../../context/Socket/SocketContext'
import toastError from '../../errors/toastError'
import api from '../../services/api'
import { useStyles } from './style'
export function LastAnnoucement({ offsetSetter }) {
  const classes = useStyles()
  const theme = useTheme()
  const [lastAnnouncement, setLastAnnouncement] = useState(null)

  async function readLastAnnouncement() {
    try {
      const { data } = await api.get('/announcements')
      return data
    } catch (err) {
      toastError(err)
    }
  }
  const socketManager = useContext(SocketContext)

  useEffect(async () => {
    const data = await readLastAnnouncement()
    if (!data?.records) return

    const handlePriorityAnnouncement = data.records.find(
      announcement =>
        announcement.priority === 1 &&
        announcement.status === true &&
        !announcement.isConnectionAnnouncement
    )
    setLastAnnouncement(handlePriorityAnnouncement)
    offsetSetter(!!handlePriorityAnnouncement)
  }, [])

  useEffect(() => {
    const companyId = localStorage.getItem('companyId')
    const socket = socketManager.GetSocket(companyId)

    socket.on('company-announcement', async data => {
      const announcements = await readLastAnnouncement()

      const priorityAnnouncement = announcements.records.find(
        announcement =>
          announcement.priority === 1 &&
          announcement.status === true &&
          !announcement.isConnectionAnnouncement
      )

      setLastAnnouncement(priorityAnnouncement)
      offsetSetter(!!priorityAnnouncement)
    })

    return () => {
      socket.off('company-announcement')
    }
  }, [socketManager])

  const colorPriority = priority => {
    if (priority === 1) {
      return theme.palette.red_100.main
    }
    if (priority === 2) {
      return theme.palette.yellow_400.main
    }
    if (priority === 3) {
      return theme.palette.green_200.main
    }
  }

  return lastAnnouncement &&
    lastAnnouncement.priority === 1 &&
    lastAnnouncement.status === true ? (
    <div
      className={classes.infoBox}
      style={{
        backgroundColor: colorPriority(lastAnnouncement.priority)
      }}
    >
      {/* <i class="start-icon fa fa-exclamation-triangle faa-flash animated"></i> */}
      <button
        className={classes.infobutton}
        onClick={() => offsetSetter(false)}
      >
        <X size={18} />
      </button>
      <p className={classes.infoParagraph}>
        <span className={classes.announcementText}>
          {lastAnnouncement.text}
        </span>
        <a
          target="_blank"
          href={lastAnnouncement.linkout}
          className={classes.announcementLink} rel="noreferrer"
        >
          {lastAnnouncement.linkout}
        </a>
      </p>
      <p>Status: {lastAnnouncement.status}</p>{' '}
      {/* Adicione esta linha para exibir o status */}
    </div>
  ) : null
}
